<template>

</template>
<script>
    export default {
        methods: {
            handleShowData (id, name) {
                this.$alert(
                    `<iframe src="https://data.711.cn/resource/${id}?iframe=1" frameborder="0" width="100%" height="500"></iframe>`,
                    name, {
                        customClass: 'data-iframe',
                        dangerouslyUseHTMLString: true
                    })
            },
            handlePublishScope (v) {
                const params = v ? {publish_scope: 'all'} : {publish_scope: ''}

                this.$router.push({
                    path: this.pageUrl,
                    query: {
                        ...this.$route.query,
                        ...params
                    }
                })
            },
            searcher () {
                this.handleClearFilter()
                this.handleFilter('q', this.search)
            },
            operationLoad () {
                this.load()
            },
            load () {
                this.loading = true
                if(!this.params.per_page) {
                    this.params.per_page = 100
                }
                this.$http
                    .get(this.pageUrl + '?' + this.objectToQuery(this.params))
                    .then(response => {
                        if(response.success) {
                            this.dataSource = response.data
                            this.pagination = response.pagination
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false
                    })
            },
            loadNews () {
                this.loading = true
                if(!this.params.per_page) {
                    this.params.per_page = 100
                }
                this.$http
                    .get('/news_resource/data?' + this.objectToQuery(this.params))
                    .then(response => {
                        if(response.success) {
                            this.dataSource = response.data
                            this.pagination = response.pagination
                            this.$nextTick(function() {
                                const newsCartIds = this.newsCart.map(item => item.id)
                                this.dataSource.forEach(row => {
                                    if(newsCartIds.indexOf(row.id) !== -1){
                                        this.$refs.newsTable.toggleRowSelection(row, true)
                                    }
                                })
                                this.amountPrice = parseFloat(this.newsCart.reduce((acc, cur) => acc + cur.price, 0).toFixed(16))
                            })

                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false
                    })
            },
            handleSearch () {
                this.$router.push({
                    path: this.pageUrl,
                    query: {
                        ...this.$route.query,
                        ...params
                    }
                })
            },
            //筛选
            handleFilter (field, query) {
                this.$router.push({
                    path: this.pageUrl,
                    query: {
                        ...this.$route.query,
                        [field]: query,
                        page: 1,
                        _mode: 'es'
                    }
                })
            },
            clearFilter (key, item) {
                //清除一个搜索
                var searchs = window.location.search
                var num = 0
                for(var i = 0; i < searchs.length; i++) {
                    if(searchs[i] == '=') {
                        num += 1
                    }
                }

                switch(num) {
                    case 2:
                        this.selected = []
                        this.params = {}
                        this.$router.push(this.pageUrl)
                        break
                    default:
                        var searchlist = searchs.split('?')[1].split('&')

                        var newsearchlist = []

                        for(var i = 0; i < searchlist.length; i++) {
                            if(searchlist[i].indexOf(key) == -1) {
                                //如果等于-1  说明不匹配成功，删除该字段，其他字段可用
                                newsearchlist.push(searchlist[i])
                            }
                        }
                        var newsearch = '?'
                        for(var j = 0; j < newsearchlist.length; j++) {
                            newsearch += newsearchlist[j] + '&'
                        }

                        this.$router.push(this.$route.path + newsearch)
                        for(var i in this.$route.query) {
                            var item = this.$route.query[i]
                            if(item != '') {
                                this.params = {}
                                this.handleFilter(i, item)
                            }
                        }

                        break
                }
            },
            //清空搜索
            handleClearFilter () {
                this.selected = []
                this.params = {}
                this.$router.push(this.pageUrl)
            },
            handleBatchCart (taxonomy) {
                this.$confirm('是否批量将列表中的媒体加入购物车？如果媒体存在多个价格，那么系统将默认优先选择第一价格。', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    var resource_ids = []
                    this.dataSource.map((v) => {
                        if(v.publish_status === 'online') {
                            if(!v.cart) {
                                resource_ids.push(v.id)
                            }
                        }
                    })

                    if(resource_ids.length) {
                        this.$refs['cart-select'].$emit('batchSubmit', resource_ids, taxonomy, this.load)
                    }
                }).catch(() => {})

            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/resource/Mixins.vue